import { render, staticRenderFns } from "./DeletedProjects.vue?vue&type=template&id=5b71da7b"
import script from "./DeletedProjects.vue?vue&type=script&lang=js"
export * from "./DeletedProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports